import React from "react";

export default function SearchBar({ value, onChange, placeholder }) {
    return (
        <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{
                width: "80%",
                padding: 14,
                marginBottom: 32,
                fontSize: 18,
                borderRadius: 10,
                border: "1.5px solid #b2bec3",
                boxShadow: "0 2px 8px #e3e6ea",
                outline: "none",
                background: "#fff",
                fontFamily: "inherit",
                transition: "border 0.2s",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
            }}
        />
    );
}
